import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { config } from '~/notes/api/rtk/config'
import { sec } from '~/notes/api/rtk/security'

export const blank = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: config.editorApi.baseUrl,
    prepareHeaders: async (headers) => {
      const token = await sec.getAccessTokenSilently()
      if (token) {
        headers.set('authorization', `Bearer ${token}`)
      }
      return headers
    },
    credentials: 'include',
  }),
  endpoints: () => ({}),
  reducerPath: 'editor',
})
